import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import "../Scss/LibraryStyles.scss?v=1.1.3";
import api from "../../api/axios";
import {
  Box,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  Autocomplete,
  ButtonGroup,
  Button,
  CircularProgress,
  LinearProgress,
  Chip,
  Fade,
  Typography,
  Alert,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/system";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  CommonSubHeader,
  useLocationHelpers,
  NavButton,
} from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";
import { Add } from "@mui/icons-material";

// Función para convertir un string de datos separados por comas a un array de tags
function createTags(data) {
  return data.split(",").map((tag) => tag.trim());
}

const Editar = () => {
  const { goTable, goPanel, goView, buildViewUrl, buildTableUrl } =
    useLocationHelpers();
  const navigate = useNavigate();
  const { hash } = window.location;
  // Obtener bookId desde query string
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get("id");

  // const [libraryOffice, setLibraryOffice] = useState({});
  const [libraryTitle, setLibraryTitle] = useState("");
  const [libraryProcessType, setLibraryProcessType] = useState({});
  const [libraryTags, setLibraryTags] = useState(createTags("")); // Inicializar con un array vací­o
  const [libraryDescription, setLibraryDescription] = useState("");
  const [libraryCompany, setLibraryCompany] = useState({}); // Empresa seleccionada

  const [selectedFile, setSelectedFile] = useState("");
  const [bookName, setBookName] = useState("");

  const [optionsCompanies, setOptionsCompanies] = useState([]); // Lista de empresas
  // const [optionsOfficesOriginal, setOptionsOfficesOriginal] = useState([]); //
  const [optionsTypesOriginal, setOptionsTypesOriginal] = useState([]); //
  // const [optionsOffices, setOptionsOffices] = useState([]);
  const [optionsTypes, setOptionsTypes] = useState([]);
  const [optionsCompany, setOptionsCompany] = useState([]);

  // const [loadingOptionsOffices, setLoadingOptionsOffices] = useState(false);
  const [loadingOptionsTypes, setLoadingOptionsTypes] = useState(false);
  const [newTag, setNewTag] = useState(""); // Estado para nuevo tag

  const [flag, setFlag] = useState(false);

  const getData = async () => {
    const url = `${process.env.REACT_APP_API_URL}/library/edit`;

    try {
      setFlag(false);

      const response = await api.post(url, { libro: bookId });

      const { book } = response?.data;

      setOptionsCompanies([
        { company_name: "Seleccionar", id: 0 },
        ...response?.data?.companies,
      ]);

      // setOptionsOfficesOriginal(response?.data?.offices); //
      setOptionsTypesOriginal(response?.data?.cases_types); //

      // filterOfficesByCompany(book?.company_id, response?.data?.offices); // Inicializa despachos filtrados
      filterProcessTypesByCompany(
        book?.company_id,
        response?.data?.cases_types,
      ); // Inicializa tipos de procesos filtrados

      setBookName(book?.file);
      setLibraryCompany(book?.company_relation);
      // setLibraryOffice(book?.offices_relation);
      setLibraryTitle(book?.title);
      setLibraryProcessType(book?.types_relation);
      setLibraryTags(createTags(book?.tags));
      setLibraryDescription(book?.description);
      setSelectedFile({ name: book?.file });

      setFlag(true);
    } catch (error) {
      setFlag(false);
      console.log(error);
    }
  };

  // const filterOfficesByCompany = (companyId, options) => {
  //   if (!companyId || companyId === 0) {
  //     setOptionsOffices([{ office_name: "Seleccionar", id: 0 }]);
  //     setLibraryOffice(null);
  //     return;
  //   }

  //   const newArray = options ? options : optionsOfficesOriginal;

  //   const filtered = newArray.filter(
  //     (office) => office.company_id === companyId,
  //   );

  //   setOptionsOffices([{ office_name: "Seleccionar", id: 0 }, ...filtered]);
  //   setLibraryOffice(null);
  // };

  // Función para filtrar tipos de proceso según empresa
  const filterProcessTypesByCompany = (companyId, options) => {
    if (!companyId || companyId === 0) {
      setOptionsTypes([{ case_type: "Seleccionar", id: 0 }]);
      setLibraryProcessType(null); // Reinicia selección
      return;
    }

    const newArray = options ? options : optionsTypesOriginal;

    const filtered = newArray.filter((type) => type.company_id === companyId);

    setOptionsTypes([{ case_type: "Seleccionar", id: 0 }, ...filtered]);
    setLibraryProcessType(null); // Reinicia selección
  };

  const handleLibrarysFormInformation = async () => {
    const isValid = validateFields();

    if (!isValid) {
      return showValidationErrors();
    }

    if (!selectedFile) {
      Swal.fire({
        title: "¡Error!",
        text: "Por favor selecciona un archivo",
        icon: "error",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    const formData = new FormData();
    formData.append("book_id", bookId);
    formData.append("file", selectedFile);
    formData.append("file_name", selectedFile.name);
    formData.append("title", libraryTitle);
    // formData.append("office_id", libraryOffice?.id);
    formData.append("company_id", libraryCompany?.id);
    formData.append("type", libraryProcessType?.case_type);
    formData.append("tags", libraryTags.join(", "));
    formData.append("description", libraryDescription.replace(/\n/g, "<br />"));

    const queryUrl = `${process.env.REACT_APP_API_URL}/library/update`;

    Swal.fire({
      title: "¿Desea guardar los cambios?",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Guardar",
      denyButtonText: "Volver",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await api.post(queryUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.error) {
            Swal.fire({
              title: "¡No se guardaron los cambios!",
              text: "Por favor intentelo nuevamente.",
              icon: "error",
              confirmButtonColor: "#1ab394",
            });
          } else {
            Swal.fire({
              title: "¡Guardado!",
              text: "El libro se ha actualizado correctamente.",
              icon: "success",
              confirmButtonColor: "#1ab394",
            }).then(() => {
              // Redirigir al detalle del libro actualizado
              navigate(`/biblioteca/ver?id=${bookId}`);
              // navigate(`/biblioteca/ver?id=${bookId}`, { replace: true });
            });
          }
        } catch (error) {
          Swal.fire({
            title: "Error en el servidor",
            text: "Ocurrió un problema al guardar los cambios.",
            icon: "error",
            confirmButtonColor: "#1ab394",
          });
          console.error("Error en actualización:", error);
        }
      } else {
        Swal.fire("Los cambios no se han guardado", "", "info");
      }
    });
  };

  const validateFields = () => {
    const fields = [
      { value: libraryCompany?.id, name: "Empresa" },
      // { value: libraryOffice?.id, name: "Despacho" }, // Verificamos el ID del objeto en autocomplete
      { value: libraryTitle, name: "Tí­tulo" },
      { value: libraryProcessType?.id, name: "Tipo de Proceso" }, // Verificamos el ID del objeto en autocomplete
      { value: libraryTags.length, name: "Etiquetas" }, // Verificamos si hay tags
      { value: libraryDescription, name: "Descripción" },
    ];

    return fields.every((field) => {
      if (field.value == null && field.value == "undefined") {
        return false; // El campo es null o undefined
      }

      if (field.value) {
        return field.value !== ""; // Verificamos que la cadena no estí© vací­a despuí©s de trim
      }
    });
  };

  const showValidationErrors = () => {
    const fields = [
      { value: libraryCompany?.id, name: "Empresa" },
      // { value: libraryOffice?.id, name: "Despacho" },
      { value: libraryTitle, name: "Tí­tulo" },
      { value: libraryProcessType?.id, name: "Tipo de Proceso" },
      { value: libraryTags.length, name: "Etiquetas" }, // Verificamos si hay tags
      { value: libraryDescription, name: "Descripción" },
    ];

    const missingFields = fields
      .filter((field) => field.value === "" || field.value === 0)
      .map((field) => `<li>${field.name}</li>`)
      .join("");

    Swal.fire({
      title: "¡Error!",
      icon: "error",
      html: `<div style="text-align: start;">Por favor rellene los campos: <ul >${missingFields}</ul></div>`,
      confirmButtonColor: "#1ab394",
      toast: false, // Asegúrate de que el toast estí© en 'false', ya que los toasts son notificaciones flotantes.
    });
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const InputFileUpload = ({ text }) => (
    <Button
      component="label"
      startIcon={<CloudUploadIcon />}
      sx={{
        border: "2px dashed",
        height: "100px",
        "& .MuiSvgIcon-root": { fontSize: "25px !important" },
      }}
    >
      {text}
      <VisuallyHiddenInput type="file" onChange={handleFileChange} />
    </Button>
  );

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0 && files[0].type === "application/pdf") {
      setSelectedFile(files[0]);
      // console.log("Archivo seleccionado:", files[0]);
    } else {
      Swal.fire({
        title: "¡Error!",
        text: "Solo se permite formato PDF",
        icon: "error",
        confirmButtonColor: "#1ab394",
      });
    }
  };

  const handleAddTag = () => {
    if (newTag && !libraryTags.includes(newTag.trim())) {
      setLibraryTags([...libraryTags, newTag.trim()]);
    }
    setNewTag(""); // Limpia el campo de texto despuí©s de agregar
  };

  const handleDeleteTag = (tagToDelete) => {
    setLibraryTags(libraryTags.filter((tag) => tag !== tagToDelete));
  };

  const inputFields = [
    {
      label: "Empresa",
      key: "companyId",
      options: optionsCompanies,
      setFilter: (value) => {
        setLibraryCompany(value);
        // filterOfficesByCompany(value ? value.id : null);
        filterProcessTypesByCompany(value ? value.id : null);
      },
      isOptionEqualToValue: (option, value) => option?.id === value?.id,
      getOptionLabel: (option) => option?.company_name || "",
      type: "autocomplete",
      value: libraryCompany || null,
    },
    // {
    //   label: "Despacho",
    //   key: "officeId",
    //   options: optionsOffices,
    //   setFilter: (value) => setLibraryOffice(value),
    //   isOptionEqualToValue: (option, value) => option?.id === value?.id,
    //   getOptionLabel: (option) => option?.office_name || "",
    //   type: "autocomplete",
    //   value: libraryOffice || null,
    // },
    {
      label: "Tipo de proceso",
      key: "processTypeId",
      options: optionsTypes,
      loading: loadingOptionsTypes,
      setFilter: (value) => setLibraryProcessType(value), // Guardar el nombre
      handleOpen: () => setLoadingOptionsTypes(true),
      handleClose: () => setLoadingOptionsTypes(false),
      isOptionEqualToValue: (option, value) =>
        option.case_type === value?.case_type,
      getOptionLabel: (option) => option.case_type || "", // Mostrar el nombre
      type: "autocomplete",
      value: libraryProcessType || null, // Comparar directamente con el nombre
    },
    {
      label: "Etiquetas",
      key: "tagsId",
      type: "tags", // Nuevo tipo para etiquetas
    },
    {
      label: "Tí­tulo",
      key: "titleId",
      type: "text",
      setFilter: (value) => setLibraryTitle(value),
      value: libraryTitle || "",
    },

    {
      label: "Descripción",
      key: "description",
      type: "textarea",
      setFilter: (value) => setLibraryDescription(value),
      value: libraryDescription || "",
    },
  ];

  useEffect(() => {
    getData();
  }, []);

  // Generar la URL del PDF con cachí© deshabilitado
  const generatePdfUrl = (fileName) => {
    return `${
      process.env.REACT_APP_API_URL
    }/library/book?pdf=${fileName}&v=${Date.now()}`;
  };
  // Obtener archivo PDF
  const getPdfFile = async (fileName) => {
    const url = generatePdfUrl(fileName);
    try {
      const response = await api.post(url, { responseType: "blob" });

      // Verificar si la respuesta es un PDF
      if (response.headers["content-type"] !== "application/pdf") {
        const errorData = await response.data.text(); // Leer el contenido de error
        throw new Error(`Error: ${errorData}`); // Lanza un error con el mensaje
      }

      return response.data; // Retorna el blob
    } catch (error) {
      console.error("Error al obtener el PDF:", error);
      throw error; // Propaga el error
    }
  };
  // Manejar la descarga del PDF
  const handleDownloadPdf = async (fileName) => {
    try {
      const pdfBlob = await getPdfFile(fileName);
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Crear un enlace de descarga
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName; // Nombre del archivo que se descargará
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error al descargar el PDF:", error);
    }
  };

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Biblioteca" subTitle="Editar" />

      <Fade timeout={600} in={flag}>
        <Box
          component="form"
          sx={{ margin: "auto", "& > :not(style)": {} }}
          noValidate
          autoComplete="off"
          className="formMainContainer"
        >
          <Grid
            container
            style={{ textAlign: "center" }}
            p={2}
            className="fontSize"
          >
            {inputFields.map((field) => (
              <Grid
                item
                xs={12}
                md={
                  field.key == "description" ||
                  field.key == "titleId" ||
                  field.key == "tagsId"
                    ? 12
                    : 6
                }
                key={field.key}
                sx={{ padding: "5px" }}
              >
                {field.type === "tags" ? (
                  <div>
                    {/* Campo para añadir nuevos tags */}
                    <TextField
                      label="Nuevo tag"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={newTag}
                      onChange={(e) => setNewTag(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Evita que haga submit del formulario
                          handleAddTag();
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <CustomButtonPlusIcon
                            icon={Add}
                            variant="outlined"
                            color="success"
                            handleFunction={handleAddTag}
                          />
                        ),
                      }}
                    />
                    {/* Muestra los tags como chips */}
                    <div style={{ marginTop: "10px" }}>
                      {libraryTags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.toUpperCase()}
                          size="small"
                          variant="contained"
                          onDelete={() => handleDeleteTag(tag)}
                          style={{ margin: 4, borderRadius: "10px" }}
                        />
                      ))}
                    </div>
                  </div>
                ) : field.type === "autocomplete" ? (
                  <FormControl className="inputFormCreate">
                    <Autocomplete
                      id={field.key}
                      className="selectWithInput"
                      value={field.value} // Utiliza el valor actual para vincular la selección
                      size="small"
                      onChange={(event, value) => field.setFilter(value)}
                      open={field.loading}
                      onOpen={field.handleOpen}
                      onClose={field.handleClose}
                      isOptionEqualToValue={field.isOptionEqualToValue}
                      getOptionLabel={field.getOptionLabel}
                      options={field.options}
                      loading={field.loading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={field.label}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <Fragment>
                                {field.loading && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                ) : field.type === "textarea" ? (
                  <FormControl style={{ width: "100%" }}>
                    <FormLabel sx={{ textAlign: "left" }}>
                      {field.label}
                    </FormLabel>
                    <textarea
                      style={{
                        height: "100px",
                        resize: "none",
                        padding: "6px 13px",
                        fontSize: "14px",
                        border: "1px solid rgba(128, 128, 128, 0.35)",
                      }}
                      onChange={(event) => field.setFilter(event.target.value)}
                      value={field.value}
                    />
                  </FormControl>
                ) : (
                  <FormControl style={{ width: "100%" }}>
                    <TextField
                      value={field.value}
                      label={field.label}
                      onChange={(e) => field.setFilter(e.target.value)}
                      size="small"
                    />
                  </FormControl>
                )}
              </Grid>
            ))}
            <Grid item xs={12} container>
              <Grid item xs={12} mt={2} mb={2}>
                <InputFileUpload text={"FICHERO (PDF)"} />
              </Grid>
              <Grid item xs={12}>
                <Alert severity="info">
                  {selectedFile.name
                    ? "Fichero seleccionado: " + selectedFile.name
                    : ""}
                  <Button
                    variant="outlined"
                    onClick={() => handleDownloadPdf(bookName)}
                    size="small"
                    sx={{
                      ml: "20px",
                    }}
                  >
                    Descargar PDF
                  </Button>
                </Alert>
              </Grid>
              <Grid item xs={12}>
                <Alert severity="warning" sx={{ textTransform: "uppercase" }}>
                  El archivo anterior será eliminado.
                </Alert>
              </Grid>
            </Grid>
          </Grid>
          <ButtonGroup
            sx={{
              width: "100%",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Button
              onClick={handleLibrarysFormInformation}
              variant="contained"
              color="success"
              fullWidth
            >
              Guardar
            </Button>
            <NavButton
              to={buildViewUrl("biblioteca", bookId)}
              onClick={() => goView("biblioteca", bookId)}
              variant="outlined"
              color="info"
              fullWidth
            >
              Ver
            </NavButton>
            <NavButton
              to={buildTableUrl("biblioteca")}
              onClick={() => goTable("biblioteca", "Biblioteca")}
              variant="outlined"
              color="error"
              fullWidth
            >
              Tabla
            </NavButton>
          </ButtonGroup>
        </Box>
      </Fade>
    </div>
  );
};

export default Editar;
